export default function () {
	return {
		route_from: undefined,
		loading_activities: false,
	}
}
